<template>
    <el-dialog label-width="120px" label-position="top" :fullscreen="true" :visible="visible"
               @closed="closed" @close="$emit('close', false)" @opened="opened" :destroy-on-close="true">
        <slot name="title">
            <h3 class="text-center">{{ $t(`account.category.title.${edit ? 'update' : 'create'}`) }}</h3>
            <hr>
        </slot>
        <el-row>
            <el-col :span="12" :offset="6">
                <el-form :model="form" size="medium" :rules="rules" ref="categoryForm">
                    <el-form-item label="Category name" label-width="100" prop="name">
                        <el-input placeholder="Enter category name" @keyup.enter.native="submitForm" ref="input"
                                  v-model="form.name" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row slot="footer" class="dialog-footer">
            <el-col :span="12" :offset="6">
                <el-button @click="$emit('close', false)">Cancel</el-button>
                <el-button :disabled="!submittable" :loading="loading" type="primary" @click="submitForm">
                    {{ $t(`account.category.button.${edit ? 'update' : 'create'}`) }}
                </el-button>
            </el-col>
        </el-row>

    </el-dialog>
</template>

<script>
export default {
  name: 'CreateEditCategory',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    category: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data () {
    return {
      form: {
        name: this.category.name || ''
      },
      rules: {
        name: [
          { required: true, message: 'Please, enter the category name', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  computed: {
    submittable () {
      return !!this.form.name.length
    },
    edit () {
      return this.category && this.category.id
    }
  },
  methods: {
    opened () {
      if (this.category && this.category.id) {
        this.form.name = this.category.name
      }
      this.$refs.input.focus()
    },
    closed () {
      Object.keys(this.form).forEach((k) => {
        this.form[k] = ''
      })
      this.loading = false
    },
    submitForm () {
      this.$refs.categoryForm.validate((valid) => {
        if (valid) {
          this.askQuestion(this.$t(`account.category.confirm.${this.edit ? 'update' : 'create'}`), () => {
            this.loading = true
            if (this.edit) {
              this.$accountService.updateCategory(this.category.id, this.form)
                .then(data => {
                  this.notify(this.$t('account.category.message.updated'), this.$t('status.success'))
                  this.$emit('category-updated', data)
                  this.$emit('close')
                })
                .catch(this.afterSubmitError)
                .then(() => {
                  this.loading = false
                })
            } else {
              this.$accountService.createCategory(this.form)
                .then(data => {
                  this.notify(this.$t('account.category.message.created'), this.$t('status.success'))
                  this.$emit('category-created', data)
                  this.$emit('close')
                })
                .catch(this.afterSubmitError)
                .then(() => {
                  this.loading = false
                })
            }
          })
        }
      })
    },
    afterSubmitError (error) {
      if (error.response) {
        this.notify(error.response.data.message, error.response.statusText || this.$t('status.error'), 'error')
      } else if (error.request) {
        this.notify(error.request.message, this.$t('status.error'), 'error')
      } else {
        this.notify(error.message, this.$t('status.error'), 'error')
      }
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
